import { Component, Input, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { PageComponent } from '../page/page.component';

@Component({
  selector: 'crowdctrl-list-page',
  standalone: true,
  imports: [PageComponent],
  template: `
    <crowdctrl-page
      [pageTitle]="pageTitle"
      [defaultHref]="defaultHref"
      [backButtonIcon]="backButtonIcon"
      [showRefresh]="showRefresh"
      [showHeader]="showHeader"
      [showFooter]="showFooter"
      [footerText]="footerText"
      [loadFn]="loadFn"
      [refreshFn]="refreshFn"
      [toolbarColor]="toolbarColor"
      [progressBarColor]="progressBarColor"
      [enablePwaPullRefresh]="enablePwaPullRefresh"
      contentClass="ion-padding-bottom crowdctrl-list-wrapper-content"
    >
      <ng-content></ng-content>
    </crowdctrl-page>
  `,
})
export class ListPageComponent {
  @ViewChild(PageComponent) private inner?: PageComponent;
  @Input() pageTitle = '';
  @Input() defaultHref: string | null = null;
  @Input() backButtonIcon?: string;
  @Input() showRefresh = false;
  @Input() showHeader = true;
  @Input() showFooter: boolean | null = null;
  @Input() footerText: string | null = null;
  @Input() loadFn?: () => Observable<unknown>;
  @Input() refreshFn?: () => Observable<unknown>;
  @Input() toolbarColor?: string;
  @Input() progressBarColor = 'medium';
  @Input() enablePwaPullRefresh = false;

  onRefresh(force = false): void {
    this.inner?.onRefresh(force);
  }
}
